<script>
    import { t } from '../core/i18n/language-store';
    import {get} from "svelte/store";
    import {publishConfigStore, tenantKeyStore} from "../core/app-store.js";
    import {
        addToCartHandler,
        removeFromCartHandler
    } from "../cart/cart-store.js";
    import PromoCard from "./PromoCard.svelte";

    const publishConfig = get(publishConfigStore);
    const tenantKey = get(tenantKeyStore);

    export let recommended = [];

</script>

<style>
    .section {
        display: flex;
        flex-wrap: wrap;
        gap: 20px;
        margin: 0;
    }
</style>

{#if (recommended && recommended.length > 0) }

    <div class="flex-column gap-1">

        <h2>{$t('blocks.recommendations.title')}</h2>
        <section class="section desktop-grid">
        {#each recommended as recommendation}
            <PromoCard record={recommendation}
                       publishConfig={publishConfig}
                       tenantKey={tenantKey}
                       on:removeFromCart={(record) => removeFromCartHandler(record.detail)}
                       on:addToCart={(record) => addToCartHandler(record.detail)}
            ></PromoCard>
        {/each}
        </section>
    </div>

{/if}
